import { gql } from "@apollo/client";

export const UPDATE_LINK_ACTIVE = gql`
  mutation UpdateLinkActive($slug: String!, $isActive: Boolean!) {
    updateLinkActive(input: { slug: $slug, isActive: $isActive }) {
      meetingSettingsErrorable {
        __typename
        ... on MeetingSettings {
          id
          isActive
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  }
`;
